module.exports = __webpack_public_path__ + "static/media/slack.9d8fa4f6.png";